module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10016_original.ca51b911.jpg";